import React, { Component } from "react";
import { Grid, Row, Col, Popover, OverlayTrigger } from "react-bootstrap";
import { auth, fire } from "../../firebase/index";
import withAuthorization from "../../components/Authorization/withAuthorization";
import AuthUserContext from "../../components/Auth/AuthUserContext";
import GoogleMapReact, { fitBounds } from "google-map-react";
// import { fitBounds } from "google-map-react";
import TimeStamp from "react-timestamp";
import {
  getRecipientsCount,
  getActiveRemoteCount,
  getLockCount,
} from "./DashboardHelper";

import PaymentFailPopup from "./PaymentFailPopup";
import RedemptionEndingPopup from "./RedemptionEndingPopup";
import SubscriptionEndingPopup from "./SubscriptionEndingPopup";
import TrialEndingPopup from "./TrialEndingPopup";

import { customLog } from "../../variables/Variables";

// import newRemoteAccess from "assets/img/dashboardimages/total-active-remote-access.png";
// import newLockImage from "assets/img/dashboardimages/total-number-lock-1.png";
// import recipientsImage from "assets/img/dashboardimages/recipientsimg.png";

import newRemoteAccess from "assets/img/dashboardimages/dashboardShare.png";
import newLockImage from "assets/img/dashboardimages/dashboardLock.png";
import recipientsImage from "assets/img/dashboardimages/dashboardUsers.png";

//TODO: LOCALISATION CODES, COMMENTED AWAY TO HIDE WARNING
import LocalizedStrings from "react-localization";

import "assets/css/maincss.css";
// import Chatbot from "../../views/Chatbot/Chatbot";

//TODO: LOCALISATION CODES, COMMENTED AWAY TO HIDE WARNING
let localizationStrings = new LocalizedStrings({
  en: {
    totalNumberOfLocks: "Total Locks",
    totalNumberOfRecipients: "Whitelisted Users",
    totalNumberRemoteAccess: "Remote Access",
    mapLockTitle: "All lock locations",
    mapLockTitle1: "No Locks Registered",
    overviewHeader: "Lock Overview",
    lastAccessedOn: "Last Accessed On:",
    lastAccessedBy: "Last Accessed By:",
    lastAccessedAddress: "Last Accessed Address:",
    serialLabel: "Serial: ",
  },
  ja: {
    totalNumberOfLocks: "ハードウェア数",
    totalNumberOfRecipients: "登録メンバー数",
    totalNumberRemoteAccess: "遠隔アクセス状況",
    mapLockTitle: "アクセスロケーション",
    mapLockTitle1: "登録されているロックがありません。",
    overviewHeader: "ロックの概要",
    lastAccessedOn: "最終アクセス日:",
    lastAccessedBy: "最終アクセス者:",
    lastAccessedAddress: "最後にアクセスしたアドレス:",
    serialLabel: "シリアル: ",
  },
  es: {
    totalNumberOfLocks: "Total de Candados",
    totalNumberOfRecipients: "Usuarios en la Lista Blanca",
    totalNumberRemoteAccess: "Acceso Remoto",
    mapLockTitle: "Todas las ubicaciones de candados",
    mapLockTitle1: "No hay candados registradas",
    overviewHeader: "Resumen del Candado",
    lastAccessedOn: "Último Accedida el:",
    lastAccessedBy: "Último Accedida por:",
    lastAccessedAddress: "Última Dirección Accedida:",
    serialLabel: "De Serie: ",
  },
});

// Inline CSS
//For each cardstyle's Css
// const cardStyle = {
//   padding: "0",
//   textAlign: "center",
//   margin: "10px",
//   boxShadow: "1px 3px 10px #B0B0B0"
// };

// //Each row css
// const rowStyle = {
//   marginBottom: "0px",
//   marginTop: "0px",
//   textAlign: "center",
//   padding: "0px"
// };

// //DashboardStyle Div container
// const imgDivStyle = {
//   alignContent: "center"
// };

// //DashboardImages Syles
// const imgStyle = {
//   padding: "0",
//   width: "36px",
//   height: "36px",
//   alignContent: "center",
//   margin: "auto",
//   marginBottom: "10px"
// };

// //number of users
// const numbersDisplays = {
//   fontSize: "20px",
//   fontWeight: "bolder",
//   color: "#707070"
// };

// //Card Header
// const cardHeader = {
//   color: "#707070"
// };

// //card sub header
// const cardSubheader = {
//   color: "#B0B0B0"
// };
const Marker = ({ children }) => children;

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      authUser: auth.currentUser,
      averageLat: 0,
      averageLng: 0,
      locklistArray: [],
      mapPinsArray: [],
      length: 0,
      numberOfLocks: "Loading...",
      numberOfUsers: "Loading...",
      numberOfActiveSharing: "Loading...",
      mapLoading: "Loading...",
      planType: "",
    };
    this.onlyUnique = this.onlyUnique.bind(this);
  }
  snapshotToArray = (snapshot) => {
    var returnArr = [];
    snapshot.forEach(function(childSnapshot) {
      var item = childSnapshot.val();
      item.key = childSnapshot.key;
      returnArr.push(item);
    });
    return returnArr;
  };
  onlyUnique = (value, index, self) => {
    return self.indexOf(value) === index;
  };

  componentDidMount() {
    this._isMounted = true;

    getLockCount((numOfLocks) => {
      if (!this._isMounted) return;
      this.setState({
        loading: false,
        length: numOfLocks,
        numberOfLocks: numOfLocks,
      });

      if (auth.currentUser !== null) {
        fire
          .database()
          .ref("userSettings")
          .child(auth.currentUser.uid) // get uid from auth person object
          .child("language")
          .on("value", this._langCb = (snapshot) => {
            this.setState({
              currentLanguage: snapshot.val(),
            });
          });

        fire
          .database()
          .ref("groupAccounts")
          .child(auth.currentUser.uid)
          .once("value")
          .then((snapshot) => {
            if (!this._isMounted) return;
            if (snapshot.exists()) {
              let userDetails = snapshot.val();
              if (userDetails.payment.currentPaymentType === "REDEMPTION") {
                this.setState({
                  planType: "Redemption",
                });
              } else {
                this.setState({
                  planType: "Subscription",
                });
              }
            }
          });
      }
    });

    getRecipientsCount((numOfRecipients) => {
      if (!this._isMounted) return;
      this.setState({
        loading: false,
        numberOfUsers: numOfRecipients,
      });
    });

    getActiveRemoteCount((numOfActiveRemote) => {
      if (!this._isMounted) return;
      this.setState({
        loading: false,
        numberOfActiveSharing: numOfActiveRemote,
      });
    });

    var tempLockSerialArray = [];
    fire
      .database()
      .ref("userLocks")
      .child(auth.currentUser.uid)
      .orderByKey()
      .once("value")
      .then((snapshots) => {
        if (!this._isMounted) return;
        snapshots.forEach((snapshot) => {
          tempLockSerialArray.push(snapshot.val().ip45SerialNumber);
        });
      })
      .then(() => {
        if (!this._isMounted) return;
        var url = fire.database().ref("whereourlocksat");
        var filteredLockSerials = tempLockSerialArray.filter(this.onlyUnique);
        let mapPinArray = [];
        let mapPinObject = {};
        // let sumOfLat = 0;
        // let sumOfLng = 0;
        let minLat = 90;
        let minLng = 180;
        let maxLat = -90;
        let maxLng = -180;
        let midLat = 0;
        let midLng = 0;
        let latDiff = 0;
        let lngDiff = 0;
        let diff = 0;
        filteredLockSerials.forEach((myLockSerial) => {
          if (
            myLockSerial != null &&
            myLockSerial != "" &&
            myLockSerial.length != 0
          ) {
            url
              .child(myLockSerial)
              .once("value", (snapshot) => {
                if (snapshot.exists()) {
                  const lockDetails = snapshot.val();
                  var lockLastAccessedLat = lockDetails.LatitudeLastAccessed;
                  var lockLastAccessedLng = lockDetails.LongitudeLastAccessed;
                  var lockLastAccessedPlacemark = lockDetails.Placemark;
                  var lockLastAccessedTimeStamp = lockDetails.lastAccessedTime;
                  var lockLastAccessedEmail = lockDetails.emailOfUser;

                  // sumOfLat += lockDetails.LatitudeLastAccessed;
                  // sumOfLng += lockDetails.LongitudeLastAccessed;

                  if (lockDetails.LatitudeLastAccessed > maxLat) {
                    maxLat = lockDetails.LatitudeLastAccessed;
                  }
                  if (lockDetails.LatitudeLastAccessed < minLat) {
                    minLat = lockDetails.LatitudeLastAccessed;
                  }
                  if (lockDetails.LongitudeLastAccessed > maxLng) {
                    maxLng = lockDetails.LongitudeLastAccessed;
                  }
                  if (lockDetails.LongitudeLastAccessed < minLng) {
                    minLng = lockDetails.LongitudeLastAccessed;
                  }

                  midLat = (maxLat + minLat) / 2;
                  midLng = (maxLng + minLng) / 2;
                  latDiff = maxLat - minLat;
                  lngDiff = maxLng - minLng;

                  if (latDiff === lngDiff || latDiff > lngDiff) {
                    diff = latDiff;
                  } else if (latDiff < lngDiff) {
                    diff = lngDiff;
                  }

                  mapPinObject = {
                    lockSerial: snapshot.key,
                    lockLastAccessedLat: lockLastAccessedLat,
                    lockLastAccessedLng: lockLastAccessedLng,
                    lockLastAccessedPlacemark: lockLastAccessedPlacemark,
                    lockLastAccessedTimeStamp: lockLastAccessedTimeStamp,
                    lockLastAccessedEmail: lockLastAccessedEmail,
                  };

                  mapPinArray.push(mapPinObject);
                }
                //else dont get the data
              })
              .then(() => {
                if (!this._isMounted) return;
                // let averageLat = sumOfLat / mapPinArray.length;
                // let averageLng = sumOfLng / mapPinArray.length;

                this.setState(
                  {
                    averageLat: midLat,
                    averageLng: midLng,
                    mapPinsArray: mapPinArray,
                  },
                  () => {
                    if (
                      this.map &&
                      this.state.midLat !== 0 &&
                      this.state.midLng !== 0
                    ) {
                      this.map.setCenter({ lat: midLat, lng: midLng });
                      if (diff <= 0.15) {
                        this.map.setZoom(12);
                      } else if (diff > 0.15 && diff <= 0.3) {
                        this.map.setZoom(11);
                      } else if (diff > 0.3 && diff <= 0.6) {
                        this.map.setZoom(10);
                      } else if (diff > 0.6 && diff <= 1.2) {
                        this.map.setZoom(9);
                      } else if (diff > 1.2 && diff <= 2.4) {
                        this.map.setZoom(8);
                      } else if (diff > 2.4 && diff <= 4.8) {
                        this.map.setZoom(7);
                      } else if (diff > 4.8 && diff <= 9.6) {
                        this.map.setZoom(6);
                      } else if (diff > 9.6 && diff <= 19.2) {
                        this.map.setZoom(5);
                      } else if (diff > 19.2 && diff <= 38.4) {
                        this.map.setZoom(4);
                      } else if (diff > 38.4 && diff <= 76.8) {
                        this.map.setZoom(3);
                      } else if (diff > 76.8 && diff <= 153.6) {
                        this.map.setZoom(2);
                      } else {
                        this.map.setZoom(1);
                      }
                    }
                  }
                );
              })
              .then(() => {
                customLog(this.state.mapPinsArray);
              });
          }
        });
      });
  }

  mapViewSection() {
    // const mapOptions = {
    //   styles: mapStyle
    // };
    if (this.state.numberOfLocks !== "Loading...") {
      // const bounds = {
      //   ne: {
      //     lat: 50.01038826014866,
      //     lng: -118.6525866875
      //   },
      //   sw: {
      //     lat: 32.698335045970396,
      //     lng: -92.0217273125
      //   }
      // };

      // const size = {
      //   width: 640, // Map width in pixels
      //   height: 380, // Map height in pixels
      // };

      // const { center, zoom } = this.map.fitBounds(bounds);
      if (this.state.length > 0) {
        return (
          <div
            style={{
              height: "calc(100% - 39px)",
              width: "100%",
              boxShadow: "0 2px 30px #b0b0b0",
            }}
          >
            <div className="mapDialogBox">
              {localizationStrings.mapLockTitle}
            </div>
            <GoogleMapReact
              bootstrapURLKeys={{
                key: process.env.REACT_APP_GOOGLE_MAP_API_KEY,
              }}
              // defaultCenter={{ lat: 0, lng: 0 }}
              center={{
                lat: this.state.averageLat,
                lng: this.state.averageLng,
              }}
              // defaultZoom={1}
              zoom={12}
              // options={mapOptions}
              // yesIWantToUseGoogleMapApiInternals
              // ref={(ref) => { this.map = ref; }}
              // onGoogleApiLoaded={({ map, maps }) => apiIsLoaded(map, maps)}
              onGoogleApiLoaded={({ map }) => {
                this.map = map;
              }}
            >
              {this.state.mapPinsArray.map((pin) => {
                if (
                  pin.lockLastAccessedLat !== 0 &&
                  pin.lockLastAccessedLng !== 0
                ) {
                  const popover = (
                    <Popover
                      id="popover-basic"
                      // title={localizationStrings.overviewHeader + pin.lockSerial}
                    >
                      <div class="text-center">
                        <p style={{ margin: "2px 0 0", color: "orange" }}>
                          {localizationStrings.overviewHeader}
                        </p>
                        <p
                          style={{
                            margin: "3px 0 -8px",
                            color: "grey",
                            fontSize: "13px",
                          }}
                        >
                          {localizationStrings.serialLabel + pin.lockSerial}
                        </p>
                        <hr />
                        <label>{localizationStrings.lastAccessedOn}</label>
                        <br />
                        <TimeStamp
                          time={pin.lockLastAccessedTimeStamp / 1000}
                          format="full"
                          includeDay
                          style={{
                            fontSize: "14px",
                            color: "#979797",
                            fontWeight: "600",
                          }}
                        />
                        <br />
                        <br />
                        <label>{localizationStrings.lastAccessedBy}</label>
                        <p
                          style={{
                            fontSize: "14px",
                            color: "grey",
                            marginBottom: "18px",
                          }}
                        >
                          {pin.lockLastAccessedEmail}
                        </p>
                        <label>{localizationStrings.lastAccessedAddress}</label>
                        <p style={{ fontSize: "14px", color: "grey" }}>
                          {pin.lockLastAccessedPlacemark}
                        </p>
                      </div>
                    </Popover>
                  );

                  return (
                    <Marker
                      key={pin.lockSerial}
                      lat={pin.lockLastAccessedLat}
                      lng={pin.lockLastAccessedLng}
                    >
                      <OverlayTrigger placement="right" overlay={popover}>
                        <div className="testPin"></div>
                      </OverlayTrigger>
                    </Marker>
                  );
                }
              })}
            </GoogleMapReact>
          </div>
        );
      } else {
        return (
          // <MyMap incomingLogs={this.state.ATArray} />
          <div style={{ height: "calc(100% - 39px)", width: "100%" }}>
            <div className="mapDialogBox">
              {localizationStrings.mapLockTitle1}
            </div>
            <GoogleMapReact
              bootstrapURLKeys={{
                key: process.env.REACT_APP_GOOGLE_MAP_API_KEY,
              }}
              defaultCenter={{ lat: 0, lng: 0 }}
              defaultZoom={1}
              // options={mapOptions}
            ></GoogleMapReact>
          </div>
        );
      }
    } else {
      return (
        <div style={{ textAlign: "center", fontSize: "3em" }}>Loading...</div>
      );
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    //PaymentFailPopup
    return (
      <div style={{ padding: "20px 20px 0" }}>
        <AuthUserContext.Consumer>
          {(authUser) =>
            authUser ? (
              <div id="cardContainer" style={{ fontSize: "1.2em" }}>
                <PaymentFailPopup />
                {this.state.planType === "Redemption" ? (
                  <RedemptionEndingPopup />
                ) : (
                  <SubscriptionEndingPopup />
                )}
                {this.state.planType === "Redemption" ? (
                  ""
                ) : (
                  <TrialEndingPopup />
                )}
                {/* {this.state.planType === "Redemption" ? <SubscriptionEndingPopup /> : <RedemptionEndingPopup />} */}

                <Grid
                  fluid
                  className="dashboardGrid"
                  style={{
                    height: "calc(100vh - 103px)",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Row>
                    <Col sm={4}>
                      <div className="card card-stats dashBoardCard cardStyle">
                        <div className="content cardContent">
                          <Row className="rowStyle">
                            {/* <Col xs={7}> */}
                            <div className="dashBoardIconContainer imgDivStyle">
                              <img
                                className="imgStyle"
                                src={newLockImage}
                                alt="lockImg"
                              ></img>
                            </div>
                            <div className="numbers cardHeader">
                              <span className="numbersDisplays1">
                                {this.state.numberOfLocks}
                              </span>
                              <br />
                              {localizationStrings.totalNumberOfLocks}
                            </div>
                          </Row>
                        </div>
                      </div>
                    </Col>
                    {/* End of the first card ( Number of locks) */}

                    <Col sm={4}>
                      <div className="card card-stats dashBoardCard cardStyle">
                        <div className="content cardContent">
                          <Row className="rowStyle">
                            {/* <Col xs={7}> */}
                            <div className="dashBoardIconContainer imgDivStyle">
                              <img
                                className="imgStyle"
                                src={recipientsImage}
                                alt="recipientsImage"
                              ></img>
                            </div>
                            <div className="numbers cardHeader">
                              <span className="numbersDisplays2">
                                {this.state.numberOfUsers}
                              </span>
                              <br />
                              {localizationStrings.totalNumberOfRecipients}
                            </div>
                          </Row>
                        </div>
                      </div>
                    </Col>
                    {/* End of the second card ( Number of recipients) */}

                    <Col sm={4}>
                      <div className="card card-stats dashBoardCard cardStyle">
                        <div className="content cardContent">
                          <Row className="rowStyle">
                            {/* <Col xs={7}> */}
                            <div className="dashBoardIconContainer imgDivStyle">
                              <img
                                className="imgStyle"
                                src={newRemoteAccess}
                                alt="bluetoothImage"
                              ></img>
                            </div>
                            <div className="numbers cardHeader">
                              <span className="numbersDisplays3">
                                {this.state.numberOfActiveSharing}
                              </span>
                              <br />
                              {localizationStrings.totalNumberRemoteAccess}
                            </div>
                          </Row>
                        </div>
                      </div>
                    </Col>
                    {/* End of the third card ( Number of remote access) */}
                  </Row>
                  <Row style={{ flexGrow: "1" }}>
                    {/* <div className="card card-stats dashBoardCard cardStyle">
                      <div className="cardContent pr-5 mr-5">
                        <Col sm={12}>{this.mapViewSection()}</Col>
                      </div>
                    </div> */}
                    <Col sm={12} style={{ height: "100%", padding: "0 25px" }}>
                      {this.mapViewSection()}
                    </Col>
                  </Row>
                </Grid>
              </div>
            ) : null
          }
        </AuthUserContext.Consumer>
        {/* <Chatbot/> */}
      </div>
    );
  }
}

const authCondition = (authUser) => !!authUser;
export default withAuthorization(authCondition)(Dashboard);
